(function () {
  const locale =
    (window.Shopify && window.Shopify.locale) ||
    document.documentElement.getAttribute('lang') ||
    '';
  const language = locale.toLowerCase().split('-')[0];

  const dictionaries = {
    lv: {
      'Leave a number and we\'ll text you back as soon as we\'re available (an email address works too).':
        'Atstājiet tālruņa numuru, un mēs jums atrakstīsim, tiklīdz būsim pieejami (der arī e-pasta adrese).',
      'Chat with us': 'Sazinieties ar mums',
      Assistance: 'Palīdzība',
      Chat: 'Čats',
      Contact: 'Kontakti',
      Help: 'Palīdzība',
      'Live chat': 'Tiešsaistes čats',
      'Message us': 'Rakstiet mums',
      'Need help?': 'Vajadzīga palīdzība?',
      Support: 'Atbalsts',
      'Shopify online store chat': 'Shopify tiešsaistes veikala čats',
      Automated: 'Automātiski',
      '👋 Hi, message us with any questions. We\'re happy to help!':
        '👋 Sveiki! Rakstiet mums, ja ir jautājumi. Labprāt palīdzēsim!',
      'Instant answers': 'Ātrās atbildes',
      You: 'Jūs',
      'Write message': 'Rakstiet ziņu',
      Send: 'Sūtīt',
      'Did you mean {email_address}?': 'Vai domājāt {email_address}?',
      'Return to chat': 'Atgriezties čatā',
      Today: 'Šodien',
      Yesterday: 'Vakar',
      'Track my order': 'Sekot pasūtījumam',
      'Please provide your information.': 'Lūdzu, norādiet savu informāciju.',
      'Track another order': 'Sekot citam pasūtījumam',
      'To see your order status, please provide your order details.':
        'Lai redzētu pasūtījuma statusu, norādiet pasūtījuma datus.',
      Cancel: 'Atcelt',
      'Enter order information': 'Ievadīt pasūtījuma informāciju',
      'Please message us directly if you have questions. We\'re happy to help.':
        'Ja jums ir jautājumi, rakstiet mums tieši. Labprāt palīdzēsim.',
      'My order number is': 'Mans pasūtījuma numurs ir',
      'Order number': 'Pasūtījuma numurs',
      'Please enter a valid order number with only numbers and letters, no spaces (e.g. 1006).':
        'Lūdzu, ievadiet derīgu pasūtījuma numuru, izmantojot tikai ciparus un burtus bez atstarpēm (piemēram, 1006).',
      'My email is': 'Mans e-pasts ir',
      'Email address': 'E-pasta adrese',
      'Email Address': 'E-pasta adrese',
      'There was a problem looking up your order. Please try again.':
        'Radās problēma, meklējot jūsu pasūtījumu. Lūdzu, mēģiniet vēlreiz.',
      'Before we get started': 'Pirms sākam',
      'Please provide your information so we can reply to you if you leave the chat.':
        'Lūdzu, norādiet savu informāciju, lai varam jums atbildēt, ja pametat čatu.',
      'This ensures you\'ll get our reply if you need to leave the chat.':
        'Tas nodrošina, ka saņemsiet mūsu atbildi, ja jums būs jāatstāj čats.',
      'Opt in to get special email promotions and updates. You can opt out anytime.':
        'Piekrītiet saņemt īpašus e-pasta piedāvājumus un jaunumus. Varat atteikties jebkurā laikā.',
      'First Name': 'Vārds',
      'Last Name': 'Uzvārds',
      'Start chat': 'Sākt čatu',
      'Enter a valid email address.': 'Ievadiet derīgu e-pasta adresi.',
      'Enter a valid first name.': 'Ievadiet derīgu vārdu.',
      'Enter a valid last name.': 'Ievadiet derīgu uzvārdu.',
      'Full name is too long.': 'Pilnais vārds ir pārāk garš.',
      'Sign up for updates': 'Pieteikties jaunumiem',
      'Get special email promotions and updates. You can opt out anytime.':
        'Saņemiet īpašus e-pasta piedāvājumus un jaunumus. Varat atteikties jebkurā laikā.',
      'Sign up': 'Pieteikties',
      'Success! Thanks for signing up.': 'Veiksmīgi! Paldies par pieteikšanos.',
      'Thanks! Check your email to confirm.': 'Paldies! Pārbaudiet e-pastu, lai apstiprinātu.',
      'Something went wrong!': 'Radās kļūda!',
      'Please refresh the page or try again later.':
        'Lūdzu, atsvaidziniet lapu vai mēģiniet vēlāk.',
      'Video is not available': 'Video nav pieejams',
      'Chat window': 'Čata logs',
      'Close chat window': 'Aizvērt čata logu',
      Back: 'Atpakaļ',
      Loading: 'Notiek ielāde',
      'Product image': 'Produkta attēls',
      'Attached image': 'Pievienotais attēls',
      'Attached video': 'Pievienotais video',
      'Upload an image': 'Augšupielādēt attēlu',
      'Close banner alert': 'Aizvērt paziņojumu',
      'Merchant\'s profile image': 'Tirgotāja profila attēls',
      'View all': 'Skatīt visu',
      'Add to cart': 'Pievienot grozam',
      'Added to cart': 'Pievienots grozam',
      'Buy now': 'Pirkt tagad',
      'Out of stock': 'Nav noliktavā',
      'Error adding to cart': 'Kļūda, pievienojot grozam',
      'Select {option}': 'Izvēlieties {option}',
      'Use discount': 'Izmantot atlaidi',
      'Applies automatically at checkout': 'Automātiski tiek piemērota norēķinoties',
      'Sign up for email promotions and updates or write a message to start a chat with {business_name}.':
        'Pieteicieties e-pasta piedāvājumiem un jaunumiem vai uzrakstiet ziņu, lai sāktu čatu ar {business_name}.',
      'Write a message to start a chat with {business_name}.':
        'Uzrakstiet ziņu, lai sāktu čatu ar {business_name}.',
      'If you leave the chat, you will be notified by email when {business_name} replies':
        'Ja pametīsiet čatu, jūs saņemsiet e-pasta paziņojumu, kad {business_name} atbildēs.',
      'A staff member has joined. Typical response time varies.':
        'Darbinieks ir pievienojies. Parastais atbildes laiks var atšķirties.',
      'Character limit reached': 'Sasniegts rakstzīmju limits',
      'Uploading video': 'Notiek video augšupielāde',
      'The file type you\'re trying to upload is unsupported. Accepted file types are: MP4, MOV, WebM, MPEG.':
        'Faila tips, ko mēģināt augšupielādēt, netiek atbalstīts. Atbalstītie failu tipi: MP4, MOV, WebM, MPEG.',
      'The file type you\'re trying to upload is unsupported. Accepted file types are: PNG, JPEG, JPG.':
        'Faila tips, ko mēģināt augšupielādēt, netiek atbalstīts. Atbalstītie failu tipi: PNG, JPEG, JPG.',
      'Unable to upload': 'Nevar augšupielādēt',
      'The video duration is too long. Please upload a video that is less than 1 minute long.':
        'Video ilgums ir pārāk garš. Lūdzu, augšupielādējiet video, kas ir īsāks par 1 minūti.',
      'Image size must be under 10MB.': 'Attēla izmēram jābūt mazākam par 10 MB.',
      'Video size must be under 1GB.': 'Video izmēram jābūt mazākam par 1 GB.',
      'Something went wrong while uploading the video. Please try again.':
        'Augšupielādējot video, radās kļūda. Lūdzu, mēģiniet vēlreiz.',
      'Chat is unavailable right now': 'Čats pašlaik nav pieejams',
      'A technical problem occurred. Please wait a few moments and try again.':
        'Radās tehniska problēma. Lūdzu, uzgaidiet brīdi un mēģiniet vēlreiz.',
      'Try again': 'Mēģināt vēlreiz',
      'Complete Inbox installation': 'Pabeigt Inbox instalēšanu',
      'Inbox didn\'t install properly. Complete the installation to use chat.':
        'Inbox nav pareizi instalēts. Pabeidziet instalēšanu, lai izmantotu čatu.',
      'Install Inbox': 'Instalēt Inbox',
      'Not delivered.': 'Nav piegādāts.',
      Retry: 'Mēģināt vēlreiz',
      'Image unavailable': 'Attēls nav pieejams',
      'No internet connection': 'Nav interneta savienojuma',
      'By proceeding, you agree to the sharing of your data with third parties for the provision, and improvement, of the services. This site is protected by hCaptcha and its {privacy_policy} and {terms_of_service} apply.':
        'Turpinot, jūs piekrītat savu datu kopīgošanai ar trešajām pusēm pakalpojumu nodrošināšanai un uzlabošanai. Šo vietni aizsargā hCaptcha, un ir spēkā tās {privacy_policy} un {terms_of_service}.',
      'Privacy Policy': 'Privātuma politika',
      'Terms of Service': 'Pakalpojuma noteikumi',
      'You sent:': 'Jūs nosūtījāt:',
      'Customer Support:': 'Klientu atbalsts:',
    },
    et: {
      'Leave a number and we\'ll text you back as soon as we\'re available (an email address works too).':
        'Jätke telefoninumber ja kirjutame teile tagasi niipea, kui oleme saadaval (sobib ka e-posti aadress).',
      'Chat with us': 'Vestelge meiega',
      Assistance: 'Abi',
      Chat: 'Vestlus',
      Contact: 'Kontakt',
      Help: 'Abi',
      'Live chat': 'Reaalajas vestlus',
      'Message us': 'Kirjutage meile',
      'Need help?': 'Vajate abi?',
      Support: 'Tugi',
      'Shopify online store chat': 'Shopify veebipoe vestlus',
      Automated: 'Automaatne',
      '👋 Hi, message us with any questions. We\'re happy to help!':
        '👋 Tere! Kirjutage meile, kui teil on küsimusi. Aitame hea meelega!',
      'Instant answers': 'Kiirvastused',
      You: 'Teie',
      'Write message': 'Kirjutage sõnum',
      Send: 'Saada',
      'Did you mean {email_address}?': 'Kas mõtlesite {email_address}?',
      'Return to chat': 'Tagasi vestlusesse',
      Today: 'Täna',
      Yesterday: 'Eile',
      'Track my order': 'Jälgi oma tellimust',
      'Please provide your information.': 'Palun sisestage oma andmed.',
      'Track another order': 'Jälgi teist tellimust',
      'To see your order status, please provide your order details.':
        'Tellimuse staatuse nägemiseks sisestage tellimuse andmed.',
      Cancel: 'Tühista',
      'Enter order information': 'Sisesta tellimuse info',
      'Please message us directly if you have questions. We\'re happy to help.':
        'Kui teil on küsimusi, kirjutage meile otse. Aitame hea meelega.',
      'My order number is': 'Minu tellimuse number on',
      'Order number': 'Tellimuse number',
      'Please enter a valid order number with only numbers and letters, no spaces (e.g. 1006).':
        'Palun sisestage kehtiv tellimuse number, kasutades ainult numbreid ja tähti ilma tühikuteta (nt 1006).',
      'My email is': 'Minu e-posti aadress on',
      'Email address': 'E-posti aadress',
      'Email Address': 'E-posti aadress',
      'There was a problem looking up your order. Please try again.':
        'Tellimuse otsimisel tekkis probleem. Palun proovige uuesti.',
      'Before we get started': 'Enne alustamist',
      'Please provide your information so we can reply to you if you leave the chat.':
        'Palun sisestage oma andmed, et saaksime teile vastata, kui vestlusest lahkute.',
      'This ensures you\'ll get our reply if you need to leave the chat.':
        'Nii saate meie vastuse kätte ka siis, kui peate vestlusest lahkuma.',
      'Opt in to get special email promotions and updates. You can opt out anytime.':
        'Nõustuge saama e-posti teel eripakkumisi ja uudiseid. Võite igal ajal loobuda.',
      'First Name': 'Eesnimi',
      'Last Name': 'Perekonnanimi',
      'Start chat': 'Alusta vestlust',
      'Enter a valid email address.': 'Sisestage kehtiv e-posti aadress.',
      'Enter a valid first name.': 'Sisestage kehtiv eesnimi.',
      'Enter a valid last name.': 'Sisestage kehtiv perekonnanimi.',
      'Full name is too long.': 'Täisnimi on liiga pikk.',
      'Sign up for updates': 'Liitu uudistega',
      'Get special email promotions and updates. You can opt out anytime.':
        'Saage e-posti teel eripakkumisi ja uudiseid. Võite igal ajal loobuda.',
      'Sign up': 'Liitu',
      'Success! Thanks for signing up.': 'Õnnestus! Täname liitumast.',
      'Thanks! Check your email to confirm.': 'Aitäh! Kinnitamiseks kontrollige oma e-posti.',
      'Something went wrong!': 'Midagi läks valesti!',
      'Please refresh the page or try again later.':
        'Palun värskendage lehte või proovige hiljem uuesti.',
      'Video is not available': 'Video pole saadaval',
      'Chat window': 'Vestlusaken',
      'Close chat window': 'Sulge vestlusaken',
      Back: 'Tagasi',
      Loading: 'Laadimine',
      'Product image': 'Toote pilt',
      'Attached image': 'Lisatud pilt',
      'Attached video': 'Lisatud video',
      'Upload an image': 'Laadi pilt üles',
      'Close banner alert': 'Sulge teavitus',
      'Merchant\'s profile image': 'Kaupmehe profiilipilt',
      'View all': 'Vaata kõiki',
      'Add to cart': 'Lisa ostukorvi',
      'Added to cart': 'Lisatud ostukorvi',
      'Buy now': 'Osta kohe',
      'Out of stock': 'Laost otsas',
      'Error adding to cart': 'Ostukorvi lisamisel tekkis viga',
      'Select {option}': 'Valige {option}',
      'Use discount': 'Kasuta allahindlust',
      'Applies automatically at checkout': 'Rakendub kassas automaatselt',
      'Sign up for email promotions and updates or write a message to start a chat with {business_name}.':
        'Liituge e-posti pakkumiste ja uudistega või kirjutage sõnum, et alustada vestlust ettevõttega {business_name}.',
      'Write a message to start a chat with {business_name}.':
        'Kirjutage sõnum, et alustada vestlust ettevõttega {business_name}.',
      'If you leave the chat, you will be notified by email when {business_name} replies':
        'Kui lahkute vestlusest, teavitatakse teid e-posti teel, kui {business_name} vastab.',
      'A staff member has joined. Typical response time varies.':
        'Töötaja liitus vestlusega. Tavaline vastamisaeg võib erineda.',
      'Character limit reached': 'Tähemärkide limiit on täis',
      'Uploading video': 'Video üleslaadimine',
      'The file type you\'re trying to upload is unsupported. Accepted file types are: MP4, MOV, WebM, MPEG.':
        'Failitüüp, mida proovite üles laadida, ei ole toetatud. Toetatud failitüübid: MP4, MOV, WebM, MPEG.',
      'The file type you\'re trying to upload is unsupported. Accepted file types are: PNG, JPEG, JPG.':
        'Failitüüp, mida proovite üles laadida, ei ole toetatud. Toetatud failitüübid: PNG, JPEG, JPG.',
      'Unable to upload': 'Ei saa üles laadida',
      'The video duration is too long. Please upload a video that is less than 1 minute long.':
        'Video kestus on liiga pikk. Palun laadige üles video, mis on lühem kui 1 minut.',
      'Image size must be under 10MB.': 'Pildi suurus peab olema alla 10 MB.',
      'Video size must be under 1GB.': 'Video suurus peab olema alla 1 GB.',
      'Something went wrong while uploading the video. Please try again.':
        'Video üleslaadimisel läks midagi valesti. Palun proovige uuesti.',
      'Chat is unavailable right now': 'Vestlus pole praegu saadaval',
      'A technical problem occurred. Please wait a few moments and try again.':
        'Tekkis tehniline probleem. Palun oodake hetk ja proovige uuesti.',
      'Try again': 'Proovi uuesti',
      'Complete Inbox installation': 'Lõpeta Inboxi installimine',
      'Inbox didn\'t install properly. Complete the installation to use chat.':
        'Inbox ei installitud õigesti. Vestluse kasutamiseks lõpetage installimine.',
      'Install Inbox': 'Installi Inbox',
      'Not delivered.': 'Ei saadetud.',
      Retry: 'Proovi uuesti',
      'Image unavailable': 'Pilt pole saadaval',
      'No internet connection': 'Internetiühendus puudub',
      'By proceeding, you agree to the sharing of your data with third parties for the provision, and improvement, of the services. This site is protected by hCaptcha and its {privacy_policy} and {terms_of_service} apply.':
        'Jätkates nõustute oma andmete jagamisega kolmandate osapooltega teenuste pakkumiseks ja parandamiseks. Seda saiti kaitseb hCaptcha ning kehtivad selle {privacy_policy} ja {terms_of_service}.',
      'Privacy Policy': 'Privaatsuspoliitika',
      'Terms of Service': 'Teenusetingimused',
      'You sent:': 'Teie saatsite:',
      'Customer Support:': 'Klienditugi:',
    },
  };

  const dictionary = dictionaries[language];

  if (!dictionary) {
    return;
  }

  const translatedRoots = new WeakSet();
  const observedHosts = new WeakSet();
  const translatedAttributes = ['aria-label', 'title', 'placeholder', 'value'];
  const templates = Object.entries(dictionary)
    .filter(([source]) => source.includes('{'))
    .map(([source, target]) => ({
      source,
      target,
      tokens: [...source.matchAll(/\{([^}]+)\}/g)].map((match) => match[1]),
      pattern: new RegExp(
        '^' +
          source
            .split(/(\{[^}]+\})/)
            .map((part) => {
              if (/^\{[^}]+\}$/.test(part)) {
                return '(.+?)';
              }

              return part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            })
            .join('') +
          '$'
      ),
    }));

  function translateValue(value) {
    if (!value || typeof value !== 'string') {
      return value;
    }

    const leadingWhitespace = value.match(/^\s*/)[0];
    const trailingWhitespace = value.match(/\s*$/)[0];
    const normalized = value.replace(/\s+/g, ' ').trim();
    const direct = dictionary[normalized];

    if (direct) {
      return `${leadingWhitespace}${direct}${trailingWhitespace}`;
    }

    for (const template of templates) {
      const match = normalized.match(template.pattern);

      if (!match) {
        continue;
      }

      const replacements = template.tokens.reduce((accumulator, token, index) => {
        accumulator[token] = match[index + 1];
        return accumulator;
      }, {});
      const localized = template.target.replace(/\{([^}]+)\}/g, (_, token) => replacements[token] || '');

      return `${leadingWhitespace}${localized}${trailingWhitespace}`;
    }

    return value;
  }

  function localizeAttributes(element) {
    for (const attribute of translatedAttributes) {
      if (!element.hasAttribute(attribute)) {
        continue;
      }

      const current = element.getAttribute(attribute);
      const translated = translateValue(current);

      if (translated !== current) {
        element.setAttribute(attribute, translated);
      }
    }
  }

  function localizeTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;

        if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }

        return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });

    while (walker.nextNode()) {
      const node = walker.currentNode;
      const translated = translateValue(node.nodeValue);

      if (translated !== node.nodeValue) {
        node.nodeValue = translated;
      }
    }
  }

  function localizeRoot(root) {
    localizeTextNodes(root);

    if (root instanceof Element) {
      localizeAttributes(root);
    }

    root.querySelectorAll('*').forEach(localizeAttributes);
  }

  function observeRoot(root) {
    if (!root || translatedRoots.has(root)) {
      return;
    }

    translatedRoots.add(root);
    localizeRoot(root);

    const observer = new MutationObserver(() => localizeRoot(root));
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: translatedAttributes,
    });
  }

  function observeHost(element) {
    if (!element || observedHosts.has(element)) {
      return;
    }

    observedHosts.add(element);
    localizeAttributes(element);

    const observer = new MutationObserver(() => localizeAttributes(element));
    observer.observe(element, {
      attributes: true,
      attributeFilter: translatedAttributes,
    });
  }

  function scanForInboxRoots() {
    document.querySelectorAll('inbox-online-store-chat').forEach((element) => {
      observeHost(element);

      if (element.shadowRoot) {
        observeRoot(element.shadowRoot);
      }
    });
  }

  const documentObserver = new MutationObserver(scanForInboxRoots);

  function start() {
    scanForInboxRoots();
    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    for (const delay of [250, 500, 1000, 2000, 4000]) {
      window.setTimeout(scanForInboxRoots, delay);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
